var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { toDisabledColor, toHoverColor } from '../../utils/tools';
export var builderButtonProps = function (_a) {
    var variant = _a.variant, theme = _a.theme;
    var defaultStyles = {
        height: theme.fixedHeight.lg,
        bRadius: theme.borderRadius.sm,
    };
    var button = {
        primary: __assign({ bgColor: theme.brand.color.primary.pure, bWidth: theme.borderWidth.none, bStyle: 'none', bColor: 'transparent', labelColor: theme.neutrals.pureWhite, hoverBgColor: toHoverColor(theme.brand.color.primary.pure), hoverLabelColor: theme.neutrals.pureWhite, hoverBColor: 'transparent', disabledBgColor: toDisabledColor(theme.brand.color.primary.pure), disabledLabelColor: theme.neutrals.pureWhite, disabledBColor: 'transparent' }, defaultStyles),
        secondary: __assign({ bgColor: theme.neutrals.pureWhite, bWidth: theme.borderWidth.thin, bStyle: 'solid', bColor: theme.neutrals.pureBlack, labelColor: theme.neutrals.pureBlack, hoverBgColor: toHoverColor(theme.neutrals.pureBlack), hoverLabelColor: theme.neutrals.pureWhite, hoverBColor: theme.neutrals.pureBlack, disabledBgColor: toDisabledColor(theme.neutrals.pureWhite), disabledLabelColor: toDisabledColor(theme.neutrals.pureBlack), disabledBColor: toDisabledColor(theme.neutrals.pureBlack) }, defaultStyles),
    };
    return button[variant || 'primary'];
};
var customButtonProps = function (props) {
    var theme = props.theme;
    var buttonProps = builderButtonProps(props);
    var hoverBgColor = toHoverColor(props.hoverBgColor || props.bgColor) ||
        buttonProps.hoverBgColor;
    var disabledBgColor = toDisabledColor(props.disabledBgColor || props.bgColor) ||
        buttonProps.disabledBgColor;
    var bRadius = (props === null || props === void 0 ? void 0 : props.bRadius)
        ? theme.borderRadius[props.bRadius]
        : buttonProps.bRadius;
    return {
        width: (props === null || props === void 0 ? void 0 : props.isFullWidth) ? '100%' : (props === null || props === void 0 ? void 0 : props.width) || 'auto',
        height: (props === null || props === void 0 ? void 0 : props.height) || buttonProps.height,
        bgColor: (props === null || props === void 0 ? void 0 : props.bgColor) || buttonProps.bgColor,
        labelColor: (props === null || props === void 0 ? void 0 : props.labelColor) || buttonProps.labelColor,
        bRadius: bRadius,
        bColor: (props === null || props === void 0 ? void 0 : props.bColor) || (props === null || props === void 0 ? void 0 : props.labelColor) || buttonProps.bColor,
        bWidth: (props === null || props === void 0 ? void 0 : props.bWidth) || buttonProps.bWidth,
        bStyle: (props === null || props === void 0 ? void 0 : props.bStyle) || buttonProps.bStyle,
        hoverBgColor: hoverBgColor,
        hoverLabelColor: (props === null || props === void 0 ? void 0 : props.hoverLabelColor) || buttonProps.hoverLabelColor,
        hoverBColor: (props === null || props === void 0 ? void 0 : props.hoverBColor) || buttonProps.hoverBColor,
        disabledBgColor: disabledBgColor,
        disabledLabelColor: toDisabledColor(props.disabledLabelColor || (props === null || props === void 0 ? void 0 : props.labelColor)) ||
            buttonProps.disabledLabelColor,
        disabledBColor: toDisabledColor(props.disabledBColor || props.bColor) ||
            buttonProps.disabledBColor,
    };
};
export { customButtonProps };
